import { NString } from '../../../common/types/lang';

export function extractChampionNameFromUrl(url: NString): NString {
  const match = url?.split('mobalytics.gg')?.[1]?.match(/lol\/champions\/(.+)\/build/);
  return match?.[1]?.toLowerCase();
}
